<template>
  <g>
    <g transform="scale(0.35)" class="photo-resistor">
        <text transform="matrix(1 0 0 1 45 25)" class="name"
            >조도센서{{ number }}</text
        >
        <path
            class="st0"
            d="M169.54,8.33l-2.59-1.83H56.39L53.8,8.33C27.1,27.16,11.17,57.88,11.17,90.5c0,30.87,14.27,60.03,38.42,79.03
        v77.43h0.1c-0.01,0.18-0.03,0.36-0.03,0.54c0,9.39,7.61,17,17,17s17-7.61,17-17c0-0.18-0.02-0.36-0.03-0.54h0.09V175.5h54.86v71.46
        h0.1c-0.01,0.18-0.03,0.36-0.03,0.54c0,9.39,7.61,17,17,17s17-7.61,17-17c0-0.18-0.02-0.36-0.03-0.54h0.09v-76.64
        c24.79-18.98,39.43-48.43,39.43-79.82C212.17,57.88,196.23,27.16,169.54,8.33z"
        />
        <g transform="translate(20,0)">
            <defs>
                <path
                    id="SVGID_1_Photo"
                    d="M59.42,169.39v78.5c0,3.9,3.17,7.07,7.07,7.07c3.91,0,7.07-3.17,7.07-7.07v-78.5c0-3.9-3.17-7.07-7.07-7.07
                C62.59,162.32,59.42,165.49,59.42,169.39"
                />
            </defs>
            <clipPath id="SVGID_2_Photo">
                <use xlink:href="#SVGID_1_Photo" style="overflow:visible;" />
            </clipPath>
            <linearGradient
                id="SVGID_3_Photo"
                gradientUnits="userSpaceOnUse"
                x1="547.8661"
                y1="979.5633"
                x2="549.3994"
                y2="979.5633"
                gradientTransform="matrix(9.2244 0 0 -9.2244 -4994.3311 9244.5576)"
            >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868181e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778537e-08" style="stop-color:#CECECE" />
                <stop offset="1.020836e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106338e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829549e-07" style="stop-color:#808080" />
                <stop offset="3.843946e-07" style="stop-color:#797979" />
                <stop offset="6.659740e-07" style="stop-color:#777777" />
                <stop offset="0.1253" style="stop-color:#848484" />
                <stop offset="0.4162" style="stop-color:#9F9FA0" />
                <stop offset="0.6113" style="stop-color:#9C9C9D" />
                <stop offset="0.7532" style="stop-color:#939394" />
                <stop offset="0.8778" style="stop-color:#848384" />
                <stop offset="0.9926" style="stop-color:#6F6E6E" />
                <stop offset="1" style="stop-color:#6D6C6C" />
            </linearGradient>
            <g class="pin">
                <rect
                    x="59.42"
                    y="162.32"
                    class="st1"
                    width="14.14"
                    height="92.64"
                />
                <rect
                    :id="`${pincode}PS`"
                    @click="onClick(`${pincode}PS`)"
                    class="pin-cover terminal snap"
                    x="54.42"
                    y="240.32"
                    width="25"
                    height="25"
                ></rect>
            </g>
        </g>
        <g transform="translate(-20,0)">
            <defs>
                <path
                    id="SVGID_4_Photo"
                    d="M148.42,169.39v78.5c0,3.9,3.17,7.07,7.07,7.07c3.91,0,7.07-3.17,7.07-7.07v-78.5
                c0-3.9-3.17-7.07-7.07-7.07C151.59,162.32,148.42,165.49,148.42,169.39"
                />
            </defs>
            <clipPath id="SVGID_5_Photo">
                <use xlink:href="#SVGID_4_Photo" style="overflow:visible;" />
            </clipPath>
            <linearGradient
                id="SVGID_6_Photo"
                gradientUnits="userSpaceOnUse"
                x1="557.5144"
                y1="979.5633"
                x2="559.0476"
                y2="979.5633"
                gradientTransform="matrix(9.2244 0 0 -9.2244 -4994.3311 9244.5576)"
            >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868181e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778537e-08" style="stop-color:#CECECE" />
                <stop offset="1.020836e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106338e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829549e-07" style="stop-color:#808080" />
                <stop offset="3.843946e-07" style="stop-color:#797979" />
                <stop offset="6.659740e-07" style="stop-color:#777777" />
                <stop offset="0.1253" style="stop-color:#848484" />
                <stop offset="0.4162" style="stop-color:#9F9FA0" />
                <stop offset="0.6113" style="stop-color:#9C9C9D" />
                <stop offset="0.7532" style="stop-color:#939394" />
                <stop offset="0.8778" style="stop-color:#848384" />
                <stop offset="0.9926" style="stop-color:#6F6E6E" />
                <stop offset="1" style="stop-color:#6D6C6C" />
            </linearGradient>
            <g class="pin">
                <rect
                    x="148.42"
                    y="162.32"
                    class="st2"
                    width="14.14"
                    height="92.64"
                />
                <rect
                    :id="`${pincode}MS`"
                    @click="onClick(`${pincode}MS`)"
                    class="pin-cover terminal snap"
                    x="144.42"
                    y="240.32"
                    width="25"
                    height="25"
                ></rect>
            </g>
        </g>
        <g transform="scale(0.8) translate(28,40)">
            <path
                class="st3"
                d="M21.17,90.5c0,31.21,15.8,58.73,39.84,75h101.33c24.04-16.27,39.84-43.79,39.84-75
            c0-30.58-15.17-57.62-38.39-74H59.56C36.34,32.88,21.17,59.92,21.17,90.5z"
            />
            <path
                class="st4"
                d="M60.3,92.25c0,4.23-3.43,7.65-7.65,7.65S45,96.48,45,92.25c0-4.22,3.43-7.65,7.65-7.65S60.3,88.03,60.3,92.25"
            />
            <path
                class="st5"
                d="M53.56,90.09c0,1.7-1.38,3.08-3.08,3.08s-3.08-1.38-3.08-3.08c0-1.7,1.38-3.08,3.08-3.08
            S53.56,88.39,53.56,90.09"
            />
            <path
                class="st4"
                d="M177.56,92.25c0,4.23-3.43,7.65-7.65,7.65s-7.65-3.42-7.65-7.65c0-4.22,3.43-7.65,7.65-7.65
            S177.56,88.03,177.56,92.25"
            />
            <path
                class="st5"
                d="M170.83,90.09c0,1.7-1.38,3.08-3.08,3.08s-3.08-1.38-3.08-3.08c0-1.7,1.38-3.08,3.08-3.08
            S170.83,88.39,170.83,90.09"
            />
            <polygon
                class="st6"
                points="150.17,55 150.17,32 146.67,32 143.17,32 80.17,32 80.17,20 73.17,20 73.17,39 143.17,39 143.17,48
            80.17,48 76.67,48 73.17,48 73.17,71 143.17,71 143.17,80 80.17,80 76.67,80 73.17,80 73.17,103 143.17,103 143.17,112 80.17,112
            76.67,112 73.17,112 73.17,135 143.17,135 143.17,144 80.17,144 76.67,144 73.17,144 73.17,166 80.17,166 80.17,151 150.17,151
            150.17,128 146.67,128 143.17,128 80.17,128 80.17,119 150.17,119 150.17,96 146.67,96 143.17,96 80.17,96 80.17,87 150.17,87
            150.17,64 146.67,64 143.17,64 80.17,64 80.17,55"
            />
        </g>
        <!-- Slider -->
        <g
            id="range-slider"
            style="transform: rotate(-90deg) translate(-100px, -40px)"
        >
            <g :class="{'range-show': on && !isSensorDataUploaded, 'range-hide': !on || isSensorDataUploaded}">
                <g class="slider-icon">
                    <g style="transform: scale(0.5) translate(275px, -40px);">
                        <path
                            d="m64.5,92.6c15.5,0 28-12.6 28-28s-12.6-28-28-28-28,12.6-28,28 12.5,28 28,28zm0-47.9c11,0 19.9,8.9 19.9,19.9 0,11-8.9,19.9-19.9,19.9s-19.9-8.9-19.9-19.9c0-11 8.9-19.9 19.9-19.9z"
                        />
                        <path
                            d="m68.6,23.6v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1z"
                        />
                        <path
                            d="m60.4,105.6v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1z"
                        />
                        <path
                            d="m96.4,38.5l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8 0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z"
                        />
                        <path
                            d="m23.5,105.6c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8z"
                        />
                        <path
                            d="m122.5,64.6c0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.8,4.1 4.1,4.1h12.9c2.2,1.42109e-14 4.1-1.8 4.1-4.1z"
                        />
                        <path
                            d="m10.6,68.7h12.9c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.9,4.1 4.1,4.1z"
                        />
                        <path
                            d="m102.6,106.8c1,0 2.1-0.4 2.9-1.2 1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.9,1.2 2.9,1.2z"
                        />
                        <path
                            d="m38.4,38.5c1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z"
                        />
                    </g>
                    <g style="transform:translate(155px, 265px);">
                        <path
                            style="transform: scale(0.04)"
                            d="M525.3,989.5C241.2,989.5,10,758.3,10,474.1c0-196.8,109.6-373.6,285.9-461.4c7.9-3.9,17.5-2.4,23.7,3.8c6.2,6.2,7.9,15.8,4,23.7c-32.2,65.4-48.5,135.7-48.5,208.9c0,261.4,212.7,474.1,474.1,474.1c74,0,145-16.7,211-49.5c7.9-3.9,17.5-2.4,23.7,3.8c6.3,6.3,7.9,15.8,3.9,23.7C900.5,879,723.3,989.5,525.3,989.5z"
                        />
                    </g>
                </g>
                <g id="range-container">
                    <path
                        d="M174,257c-8.96,0-16.25-7.29-16.25-16.25v-169c0-8.96,7.29-16.25,16.25-16.25s16.25,7.29,16.25,16.25v169
          C190.25,249.71,182.96,257,174,257z M174,59.83c-6.57,0-11.92,5.35-11.92,11.92v169c0,6.57,5.35,11.92,11.92,11.92
          s11.92-5.35,11.92-11.92v-169C185.92,65.18,180.57,59.83,174,59.83z"
                    />
                </g>
                <circle
                    id="slider-pin"
                    :class="{ on: on && !isSensorDataUploaded }"
                    cx="174"
                    cy="75"
                    r="26"
                />
                <polygon
                    points="168.58,138.31 174,147.7 179.42,138.31 175.56,138.31 175.56,125.8 172.44,125.8 172.44,138.31 "
                />
            </g>
        </g>
        <!-- Sensor Data -->
        <g v-if="on && $store.state.sim.userData[this.namecode]">
          <text transform="matrix(1 0 0 1 40 -20)" class="value">
            값 : {{ value }}
          </text>
        </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { pins } from '../../../../mixins/pin-util.js'

const map = function (val, a, b, c, d) {
  return ((val - a) / (b - a)) * (d - c) + c
}
var vm = new Vue({
  data: {
    range: {
      min: 0,
      max: 1024
    },
    draggable: []
  }
})
export default {
  props: ['data'],
  mixins: [pins],
  data () {
    return {
      on: false,
      socket: null,
      value: 0
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  computed: {
    ...mapGetters('sim', ['simulationResult']),
    isSensorDataUploaded () {
      return this.$store.state.sim.userData[this.namecode]
    }
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    initController () {
      if (this.on) {
        window.Draggable.get(`#${this.data.id}`).disable()
        vm.draggable = window.Draggable.create(`#${this.data.id} #slider-pin`, {
          type: 'x,y',
          bounds: `#${this.data.id} #range-container`,
          lockAxis: true,
          onClick: function (e) {
            e.stopPropagation()
          },
          onDrag: () => {
            const y = vm.draggable[0].y
            window.gsap.set(vm.draggable[0].target, { onUpdate: vm.draggable[0].update })
            this.controller(y)
          }
        })
      }
    },
    controller (val) {
      this.value = map(val, 6, 156, 0, 1030)
      if (val >= 1024) val = 1023
      this.$store.commit('socket/sendMessage', { socket: this.socket, message: { value: Math.round(this.value) } })
    },
    start (socket) {
      this.socket = socket
      this.on = true
      if (this.$store.state.sim.userData[this.namecode]) {
        this.socket.onmessage = ({ data }) => {
          data = JSON.parse(data)
          this.value = data.value
        }
      } else this.initController()
    },
    startWithInterval (value) {
      this.on = true
    },
    off () {
      this.on = false
      if (!this.socket) {
        window.Draggable.get(`#${this.data.id} #slider-pin`).disable()
        window.Draggable.get(`#${this.data.id}`).enable()
      } else this.socket = null
      this.value = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
  display: block;
  stroke: none;
  fill: none;
}
.pin:hover {
  cursor: pointer;
  .pin-cover {
    stroke-width: 6px;
    stroke: black;
    fill: #ff6f61;
  }
}
.selected {
  & path.st3,
  & .pin {
    display: block;
    stroke-width: 10px;
    stroke: #ff6f61;
  }
}
.range-hide {
  display: none;
}
.range-show {
  display: block;
}
.name {
  font-size: 30px;
}
.value {
  font-weight: 500;
  font-size: 38px;
}
.on {
  fill: #ff6f61;
}
.st0 {
  display: none;
  fill: #d6d6d6;
}
.st1 {
  clip-path: url(#SVGID_2_Photo);
  fill: url(#SVGID_3_Photo);
}
.st2 {
  clip-path: url(#SVGID_5_Photo);
  fill: url(#SVGID_6_Photo);
}
.st3 {
  fill: #ffefaa;
  stroke: #f56123;
  stroke-width: 7;
  stroke-miterlimit: 10;
}
.st4 {
  fill: #808080;
}
.st5 {
  fill: #ffffff;
}
.st6 {
  fill: #f56123;
}
</style>
